module.exports = __webpack_public_path__ + "static/chunks/src/page-home/part-get-cashback/assets/cashback-bg.1c972accac6620c8cee7efde69d72130.webp";